<template>
    <div class="flex gap-2" ref="containerRef">
        <div v-for="(img, index) in pdfImage" :key="img.image_id"
             class="group relative h-20 w-20 cursor-pointer border border-grey-40 bg-white px-1 py-1.5"
             ref="imageRefs">
            <img :src="img.fulltext_image240_url" width="120" height="120" loading="lazy" class="h-full object-contain" />
            <img :src="img.storage_path" width="120" loading="lazy" height="120"
                 :style="getImageStyle(index)"
                 class="absolute z-10 hidden h-[300px] min-w-[450px] border border-grey-40 bg-white object-contain px-[100px] py-4 group-hover:block"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ISolution, ImageRecord } from './types';
import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import _ from 'lodash';

const MAX_IMAGE_SHOW = 4;

const props = defineProps<{
    solutionProfile: ISolution;
}>();

const imageRefs = ref<HTMLElement[]>([]);
const containerRef = ref<HTMLElement | null>(null);
const { width: windowWidth, height: windowHeight } = useWindowSize();

const pdfImage = computed(() => {
    const imageOrigin = _.cloneDeep(props.solutionProfile?.PDF_IMAGE)
    return imageOrigin?.splice(0, MAX_IMAGE_SHOW) as ImageRecord[]
});

const getImageStyle = (index: number): Record<string, string> => {
    if (!imageRefs.value[index]) return {};

    const el = imageRefs.value[index] as HTMLElement;
    const rect = el.getBoundingClientRect();
    const styles: Record<string, string> = {};

    // Check horizontal position
    if (rect.left + 450 > windowWidth.value) {
        // Not enough space on the right
        styles.right = '0';
        styles.left = 'auto';
    } else {
        styles.left = '0';
        styles.right = 'auto';
    }

    // Check vertical position
    if (rect.top + 300 > windowHeight.value) {
        // Not enough space below
        styles.bottom = '100%';
        styles.top = 'auto';
    } else {
        styles.top = '100%';
        styles.bottom = 'auto';
    }

    return styles;
};

</script>
